import {
  defineComponent,
  reactive,
  watch,
  getCurrentInstance
} from '@vue/composition-api'
import RichUtil from '@/pages/Survey/components/RichUtil/index.vue'
import './index.scss'
import {
  changeIsAddText,
  addItemClick,
  changeRandomOrder,
  minusItemClick
} from '../../topicCommonUtil'
import { STR_TYPE } from '../../config'
import _ from 'lodash'
import { Message } from '@gcommon/gcommon-ui'
import { useRequest } from '@/utils/bhooks'
import { isDeleteOption } from '@/services/survey'
import { getParamsValue } from '@/utils/assist'
import OptionSettings from '../../../SurveyDetail/compontents/optionSettings'
import CommonTetxEdit from '@/components/CommonTetxEdit'
import moment from 'moment'

const CheckboxEdit = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, context) {
    const { emit } = context
    const vm = getCurrentInstance()
    //i18n 国际化
    const tran = function (initParam) {
      return vm?.proxy.$t(initParam) as string
    }
    //为了增加操作图片的字段 加的初始化func
    const initEditItem = (initObj) => {
      const inObj = _.cloneDeep(initObj)
      inObj?.topicSetting?.topicOptionSetting.forEach((item) => {
        if (item.optionName && item.optionName.includes('img')) {
          //具体为两个参数赋值 imgSrc  isImgFirst
          if (item.optionName.startsWith('<img')) {
            item.isImgFirst = true
          } else {
            item.isImgFirst = false
          }
          const vnode = document.createElement('div')
          vnode.innerHTML = item.optionName
          item.optionName = vnode.innerText
          if (vnode.childNodes.length) {
            item.imgSrc = Array.prototype.slice
              .call(vnode.childNodes)
              .map((ele, index) => {
                if (!ele.textContent) {
                  return {
                    name: `$pic_{index}`,
                    data: ele?.attributes?.['src']?.nodeValue
                  }
                }
              })
              .filter((ele) => ele)
          }
        } else {
          item.imgSrc = []
          item.isImgFirst = false
        }
      })
      return inObj
    }
    const state = reactive({
      // editItem: initEditItem(props.item) //编辑数据源
      editItem: _.cloneDeep(props.item) //图片转为富文本储存
    })

    watch(
      () => state.editItem,
      (val) => {
        emit('changeTopicContent', val)
      },
      {
        deep: true
      }
    )

    const { state: isDeleteData, run: isDeleteOptionFn } =
      useRequest(isDeleteOption)
    const minusItemClickFn = async (index, state) => {
      await minusItemClick(index, state, isDeleteOptionFn)
    }

    const changeMaxValue = (value) => {
      const val = Math.abs(parseInt(value))
      const len = state.editItem.topicSetting.topicOptionSetting.length
      state.editItem.topicSetting.optionLengthLessThan =
        val < 1 ? 1 : val > len ? len : val
      return state.editItem.topicSetting.optionLengthLessThan
    }

    const changeMinValue = (value) => {
      const val = Math.abs(parseInt(value))
      const len = state.editItem.topicSetting.topicOptionSetting.length
      state.editItem.topicSetting.optionLengthMoreThan = val > len ? len : val
      return state.editItem.topicSetting.optionLengthMoreThan
    }

    const addMatrixSubtopics = (index) => {
      const option = {
        //选项设置
        optionName: '', //选项name
        optionId: '', //选项ID
        isAddText: false, //是否允许填空
        isRequire: false, //是否必填
        isExclusive:false,// 是否与其他选项互斥
        isEncryption: false,
        format: '', //填空格式，枚举示例（number：数字、letter：字母、chinese：中文、email：Email、phone：手机号码）
        isFixedNo: false, //是否固定选项
        optionOrder: index + 1,
        key: new Date().getTime()
      }
      state.editItem.topicSetting.topicOptionSetting.splice(
        index + 1,
        0,
        option
      )
      // 给选项的order重新赋值
      state.editItem.topicSetting.topicOptionSetting.map((i, index) => {
        i.optionOrder = index + 1
      })
    }

    const deleteMatrixSubtopics = (index) => {
      if (state.editItem.topicSetting.topicOptionSetting.length < 3) {
        Message({
          message: tran('survy.choiceTips'),
          type: 'warning'
        })
      } else {
        state.editItem.topicSetting.topicOptionSetting.splice(index, 1)
      }
    }

    const optionSettingItem = reactive({
      item: state.editItem.topicSetting.topicOptionSetting?.[0],
      index: 0
    })

    const handelOptionLengthMoreThan = (value) => {
      let flag = state.editItem.topicSetting.topicOptionSetting.some(i => i.isExclusive)
      if (flag && value > 1) {
        Message({
          message: `${tran('survy.exclusivTip1')}${changeMinValue(value)}${tran('survy.exclusivTip2')}`,
          type: 'warning'
        })
        return state.editItem.topicSetting.optionLengthMoreThan = changeMinValue(1)
      }
      return state.editItem.topicSetting.optionLengthMoreThan = changeMinValue(value)
    }

    return () => {
      //题目选项
      return (
        <div class="topic-edit-content">
          <div class="topic-edit-content-item topic-edit-content-title">
            {!state.editItem.isAddStatus && (
              <div class="topic-edit-content-title-order">
                {!state.editItem.topicSetting.isAllowNull && <i>*</i>}
                {state.editItem.order}.
              </div>
            )}
            <div style={{ width: '100%' }}>
              <CommonTetxEdit
                needDynamicEvent
                initialData={state.editItem.topicName}
                placeholder={tran('survy.mulSeleName')}
                handleUpdate={(value) => {
                  state.editItem.topicName = value
                }}
              />
            </div>
          </div>
          <CommonTetxEdit
            needDynamicEvent
            initialData={state.editItem.topicSetting.topicRemark}
            placeholder={tran('survy.plcremark')}
            handleUpdate={(value) => {
              state.editItem.topicSetting.topicRemark = value
            }}
          />
          <div class="topic-edit-content-item">
            {state.editItem.topicSetting.topicOptionSetting.map(
              (sitem, index) => {
                return (
                  <div
                    class="option-radio"
                    key={`${sitem.optionId ? sitem.optionId : sitem.key}`}>
                    <el-checkbox label=""></el-checkbox>
                    <div class="option-radio-input">
                      <CommonTetxEdit
                        initialData={sitem.optionName}
                        placeholder={tran('survy.optionName')}
                        formFocus={() => {
                          optionSettingItem.item = sitem
                          optionSettingItem.index = index
                        }}
                        handleUpdate={(value, index) => {
                          sitem.optionName = value
                        }}
                      />
                    </div>
                    {sitem.isAddText && (
                      <el-input
                        onInput={(value) => {}}
                        value={''}
                        style={{ width: '220px' }}
                        size="small"
                        placeholder={tran('survy.plccontent')}></el-input>
                    )}
                    <i
                      class="el-icon-circle-plus-outline el-icon-common-class"
                      onClick={() => {
                        addMatrixSubtopics(index)
                      }}></i>
                    <i
                      class="el-icon-delete el-icon-common-class"
                      onClick={() => {
                        deleteMatrixSubtopics(index)
                      }}></i>
                  </div>
                )
              }
            )}
          </div>
          <div class="topic-edit-content-item">
            <CommonTetxEdit
              needDynamicEvent={true}
              initialData={state.editItem.topicSetting.endword}
              placeholder={tran('survy.mulend')}
              handleUpdate={(value) => {
                state.editItem.topicSetting.endword = value
              }}
            />
          </div>
          <Portal to="survey-option-settings">
            <OptionSettings
              type={props.item.topicType}
              isAllowNull={state.editItem.topicSetting.isAllowNull}
              isRandomOrder={state.editItem.topicSetting.isRandomOrder}
              optionLengthMoreThan={
                state.editItem.topicSetting.optionLengthMoreThan
              }
              optionLengthLessThan={
                state.editItem.topicSetting.optionLengthLessThan
              }
              optionSettingItem={optionSettingItem}
              onChangeOptionLengthMoreThan={(value) => {
                handelOptionLengthMoreThan(value)
              }}
              onChangeOptionLengthLessThan={(value) => {
                state.editItem.topicSetting.optionLengthLessThan =
                  changeMaxValue(value)
              }}
              onChangeOptionSettingItem={(value) => {
                state.editItem.topicSetting.topicOptionSetting.splice(
                  value.index,
                  1,
                  value.item
                )
              }}
              onChangeIsAllowNull={(value) => {
                state.editItem.topicSetting.isAllowNull = value
              }}
              onChangeIsRandomOrder={(value) => changeRandomOrder(value, state)}
            />
          </Portal>
        </div>
      )
    }
  }
})
export default CheckboxEdit
